/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Program } from '../../models/program';

export interface ListAdminPrograms$Params {}

export function listAdminPrograms(
  http: HttpClient,
  rootUrl: string,
  params?: ListAdminPrograms$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<Program>>> {
  const rb = new RequestBuilder(rootUrl, listAdminPrograms.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Program>>;
    })
  );
}

listAdminPrograms.PATH = '/admin/programs';
